import { render, staticRenderFns } from "./ComparisonField.vue?vue&type=template&id=6f5b341a"
import script from "./ComparisonField.vue?vue&type=script&lang=js"
export * from "./ComparisonField.vue?vue&type=script&lang=js"
import style0 from "./ComparisonField.vue?vue&type=style&index=0&id=6f5b341a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports